/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const contactSummaryResponseDtoSchema = z.object({
    "summary": z.nullable(z.string())
    })